import { PanBottomLeftIcon } from './PanBottomLeftIcon';

/**
 * author: Simran
 * id F5AFD529-AD6F-4A1B-AB69-E3E10FD0E654
 * name pan-bottom-left
 * version: 3.0.39
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pan-bottom-left.svg
 * tags
 */
export const PanDownLeftIcon = PanBottomLeftIcon;
export default PanDownLeftIcon